import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaNullNode } from './TypedNode'
import { SchemaNullModel } from './ViewModel'

export const SchemaNullPlugin = createSchemaPlugin(
  'Schema.Null',
  SchemaNullModel,
  SchemaNullNode
)
